const STORAGE_PREFIX = 'tpp_claim_inventory_empty_overlay_ack_';

export const inventoryEmptyOverlayStorageKey = (claimId: number): string =>
  `${STORAGE_PREFIX}${claimId}`;

export const hasAcknowledgedInventoryEmptyOverlay = (claimId: number): boolean =>
  sessionStorage.getItem(inventoryEmptyOverlayStorageKey(claimId)) === '1';

export const acknowledgeInventoryEmptyOverlay = (claimId: number): void => {
  sessionStorage.setItem(inventoryEmptyOverlayStorageKey(claimId), '1');
};
